<template>
    <AppHeader id="header"/>

    <div id="app-content">
        <div class="sub-page-back content-container">
            <button id="YmFjaw==" class="back" :class="{ 'hidden' : isMainPage }" @click="goBack">
                <img src="@img/arrow-right.svg"/>
                <label>Zurück</label>
            </button>
        </div>

        <router-view id="router-view" v-if="appDataReady"/>
    </div>

    <AppFooter v-if="appDataReady"/>

    <Transition name="fade">
        <div class="loading" v-show="isLoading">
            <div class="spinner"></div>
            <label class="label">{{ $t('general.loading') }}</label>
        </div>
    </Transition>
</template>

<script>
import AppHeader from '@components/AppHeader.vue'
import AppFooter from '@components/AppFooter.vue'

export default {
    name: 'app',
    inject: [ 'keycloak', 'util', 'session', 'baseData', 'systemConfig', 'globalState' ],
    computed: {
        isMainPage() {
            // show back button if we're not on a page that is
            // accessible by the navigation
            return !!this.$route.meta?.nav
        },
        isLoading() {
            return !this.appDataReady || this.globalState.isLoading
        },
        appDataReady() {
            const sessionAvailable      = this.session && this.session.available
            const baseDataAvailable     = this.baseData.available
            const systemConfigAvailable = this.systemConfig.available

            return sessionAvailable && baseDataAvailable && systemConfigAvailable
        }
    },
    methods: {
        goBack() {
            this.$router.push(this.$route.meta.parentPath)
        }
    },
    components: {
        AppHeader,
        AppFooter
    }
}
</script>

<style lang="scss">
@import 'assets/css/application.scss';
</style>

<stlye lang="scss" scoped>
.sub-page-back {
    height: 48px;
    padding: 8px 0;
    margin: 0 auto;

    > .back {
        width: fit-content;
        height: 100%;
        display: flex;
        align-items: center;
        font-size: 1.2em;
        font-weight: bold;
        border-radius: 8px;
        padding: 0 8px;

        &:hover {
            background-color: #00000022;
        }

        &.hidden {
            visibility: hidden;
        }

        > img {
            height: 50%;
            transform: rotate(180deg);
        }

        > label {
            margin-left: 4px;
        }
    }
}

.loading {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: #000000cc;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1001;

    > .spinner {
        width: 50px;
        height: 50px;
        border: 4px solid #fff;
        border-bottom-color: #ffffff33;
        border-radius: 50%;

        animation-name: spin;
        animation-duration: 1500ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    > .label {
        color: #fff;
        font-size: 1.4em;
        font-weight: bold;
        margin-top: 10px;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</stlye>
